const safelyExecuteQueueItem = (item) => {
    try {
        item();
    }
    catch (error) {
        console.error(`Error executing queue function during:`, error);
    }
};
const createCommercialQueue = (queueArr = []) => {
    const buffer = [...queueArr];
    let isInitialised = false;
    return {
        push(...items) {
            items.forEach((item) => {
                if (isInitialised) {
                    safelyExecuteQueueItem(item);
                }
                else {
                    buffer.push(item);
                }
            });
            return buffer;
        },
        flush() {
            isInitialised = true;
            while (buffer.length > 0) {
                const item = buffer.shift();
                safelyExecuteQueueItem(item);
            }
        },
    };
};
export { createCommercialQueue };
